'use strict';
import React from 'react';
import reactDom from 'react-dom';
import { Link } from 'react-router-dom';
import userAction from '../actions/userAction';
import userStore from '../stores/userStore';
import Loading from './loading';

class UserLogin extends React.Component {
    constructor(props) {
        super(props);
        this.onChange= this.onChange.bind(this);
        this.handleChange= this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleKeyPress = this.handleKeyPress.bind(this);
        this.state = {
            warningMsg: userStore.getState().warningMsg,
            processing: userStore.getState().processing,
            isNewUser: userStore.getState().isNewUser,
            isUserLogin: userStore.getState().isUserLogin,
            token: userStore.getState().token,
            staffId:"",
            password:"",
        }
    }

    componentDidMount(){
        userStore.listen(this.onChange);
        if(this.state.isUserLogin){
            this.props.history.push('/attendance');
        }
        userAction.warningMsg.defer('');
    }

    componentWillUnmount(){
        userStore.unlisten(this.onChange);
    }

    onChange(state){
        this.setState({
            warningMsg: state.warningMsg,
            processing: state.processing,
            isNewUser: state.isNewUser,
            token: state.token,
            isUserLogin: state.isUserLogin,
        });
    }
    componentDidUpdate(prevProps, prevState){
        if(!prevState.isUserLogin && this.state.isUserLogin != prevState.isUserLogin){
            if(this.state.isNewUser){
                this.props.history.push('/resetPassword/'+ this.state.token);
            }else{
                this.props.history.push('/attendance');
            }
        }
    }
    handleChange(e){
        let index = parseInt(e.target.getAttribute("data-index"));
        let value = e.target.value;

        if(index == 0){
            this.setState({staffId: value });
        }else{
            this.setState({password: value});
        }
    }

    handleSubmit(e){
        let staffInput = reactDom.findDOMNode(this.refs.staffId);
        let pwdInput = reactDom.findDOMNode(this.refs.pwd);
        try {
            staffInput.reportValidity();
            pwdInput.reportValidity();
        }
        catch (e){

        }
        
        
        if(!staffInput.checkValidity()) return;
        if(!pwdInput.checkValidity()) return;

        if(this.state.processing) return;

        if(this.state.staffId  != '' && this.state.password != ''){
            userAction.processing(true);
            userAction.userLogin(this.state.staffId, this.state.password);
        }
    }

    handleKeyPress(e){
        if(e.key == 'Enter'){
            this.handleSubmit();
        }
    }

    render() {
        return (

            <div className="ul-w">
                <h2> A4 International </h2>
                <div className="ul-tt">Admin Web Portal</div>
                <div className="ul-warning">{this.state.warningMsg}</div>
                <form>
                    <div className="form-group">
                        <div className="ul-in">
                            <input type="text" className="form-control" ref="staffId" placeholder="Staff Id" data-index="0" onChange={this.handleChange} required/>
                        </div>
                    </div>
                    <div className="form-group">
                        <div className="ul-in">
                            <input type="password" className="form-control" ref="pwd" placeholder="Password" data-index="1" 
                                onChange={this.handleChange} onKeyPress={this.handleKeyPress} required/>
                        </div>
                    </div>
                    <button type="button" className="btn btn-default" onClick={this.handleSubmit}>Submit</button>
                </form>
                <div className="ul-set">
                    <Link to="/forgotPassword" className="ul-fp">Forgot Password</Link>
                </div>
                <Loading processing ={this.state.processing} />
            </div>
        );
    }
}
export default UserLogin;


// WEBPACK FOOTER //
// ./app/components/userLogin.js